import { Button } from '@efexteam/components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SuccessProps {
  nextStep: () => void;
}
const Success = ({ nextStep }: SuccessProps) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CheckCircleIcon
          className="mx-auto mb-5 !block"
          sx={{ fontSize: 80, color: '#00C48C' }}
        />
        <Typography className="text-center" variant="h5">
          {t('tfSuccessTitle')}
        </Typography>
        <Typography className="!text-pretty !my-5" variant="body2">
          {t('tfSuccessDescription')}
        </Typography>
        <div className="flex justify-center gap-3">
          <Button appearance="primary" onClick={nextStep}>
            {t('done')}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Success;
